<template>
  <div>
    <div class="content" v-for="(item, index) in dataList" :key="index">
      <div class="page-section">
        <div>
          <div v-if="item.questionType == 1" class="page-section-title">
            {{ index + 1 }}. {{ item.questionDesc }}(单选)
          </div>
          <div v-if="item.questionType == 2" class="page-section-title">
            {{ index + 1 }}. {{ item.questionDesc }}(多选)
          </div>
        </div>
        <div v-if="item.questionType == 1">
          <van-radio-group
            v-model="item.answers"
            v-for="(cItem, idx) in item.optionsList"
            :key="idx"
          >
            <van-radio :name="cItem.optionsCode">
              {{ cItem.optionsCode }}、{{ cItem.optionsDesc }}
            </van-radio>
          </van-radio-group>
        </div>
        <div v-if="item.questionType == 2">
          <van-checkbox-group v-model="item.answers" v-for="(cItem, idx) in item.optionsList" :key="idx">
            <van-checkbox
              shape="square"
              :name="cItem.optionsCode"
              >{{ cItem.optionsCode }}、{{ cItem.optionsDesc }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import URL from '@/api/api'
export default {
  data() {
    return {
      radio: "",
      result: [],
      typeId: '',
      dataList: [],
    };
  },
  mounted() {
    this.typeId = this.$route.params.id;
    this.getQuestions(this.typeId)
  },
  methods:{
    //查询单个问卷所有问题
    getQuestions(typeId) {
      let data={
        typeId:typeId,
        openid:localStorage.getItem('openid')
      }
      this.$fetchGet(URL.oneQuestionnaire.url,data).then(res => {
        this.dataList = res.data.data
      })
    }

  }
};
</script>
<style scoped>
.content {
  width: 95%;
  margin: 10px auto;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  font-size: 0.3rem;
}
.van-radio,
.van-checkbox {
  padding-top: 15px;
}
</style>
